/*
Sohel  12/19/2022 3075154998 Added Data Manager Basic Info Screen and validation.
Sohel  12/19/2022 3075154998 label Changes.
Sohel 12/23/2022 3075154998 Integrated Basic Info API.
Lalitha 12/26/2022 3075154998 Integrated get API on DM code.
Sohel 01/04/2023 3075154998 disabled Fields.
dilip 01/04/2023 3075154998 disabled Fields.
Sohel 01/09/2023 3075154998 show Disable stepper value
Sohel 01/09/2023 3075154998 fixed Type issue.
Sohel 01/09/2023 3075154998 fixed page break issue.
dilip 01/10/2023 3075154998 Added unsaved popup.
Sohel 01/12/2023 3075154998 fixed page break issue.
dilip 01/12/2023 3075154998 Fixed message and status reset issue.
Sohel 01/18/2023 3075154998 Added Multi Record Format validation.
 dilip 01/20/2023 3075154998 Added Last Step functionality
Sohel 01/20/2023 3075154998 changed Dropdown Values
Ashraf 01/27/2023 3075154998 added new fields
Ashraf 01/31/2023 3075154998 fixed useEffect issue
Ashraf 01/31/2023 3075154998 fixed active step issue
Ravi 01/31/2023 3075154998 fixed unsaved popup issue
Sohel 01/02/2023 3075154998 fixed code uppercase issue
Sohel 01/02/2023 3075154998 fixed validation issue
Ashraf 02/03/2023 3075154998 fixed draft issue
sai krisha 02/13/2023 3075154998 added client code multislected checkbox filed and
Guru Prasad 02/13/2023 3075154998 fixed scroll issues in autocomplete
suresh peddavoora 02/22/2023 3075154998 New UI changes implemented
suresh peddavoora 02/27/2023 3075154998 New UI changes
Rohini 03/01/2023 3075154998 worked on the code enhancements.
sohel 03/06/2023 3075154998 Added validation message for existing value
Raghu 03/20/2023 3075154998 fixed input field in responsive
Prakash 03/21/2023 3075154998 Fixed alignments issue.
Akhila 04/19/2023 3075154998 client code dropDown Data fix
 Ravi 04/20/2023 3075154998 implement dynamic field name
 Ravi 04/24/2023 3075154998 Added popup in dynamic field name
 Prakash 24/04/2023 3075154998 fixed alignment issue for input filed
Sohel 04/26/2023 2692790263 Fixed Created FOr Validation Issue
 Ravi 04/27/2023 3075154998 show  dynamic field name conditionally
 Akhila 05/16/2023 3075154998 comment out disable for created for
 Ravi 05/23/2023 3075154998 Added Export Format file Field
Akhila 06/12/2023 3075154998 added role access
Sohel 06/19/2023 3075154998 Enable Save Button
Akhila 06/23/2023 3075154998 report folder path added
Suresh Peddavoora 06/23/2023 3075154998 Fixed report folder path alignments
Ravi 06/23/2023 3075154998 fixed submit issue
Ravi 06/15/2023 3075154998 removed by default initial value folder path and output file name
Akhila 30/06/2023 3075154998 condtionaly label name change for folder path and file name
Gireesh 08/12/2023 3075154998 Added folder path and output file name fields in imports
uday 08/12/2023 3075154998 fixed inputfield alignments issues
Gireesh 11/12/2023 3075154998 added code and description validations
Gireesh 12/12/2023 3075154998 changed labels
*/
import React, {useContext, useEffect, useRef, useState} from 'react';
import {Formik} from 'formik';
import * as Yup from 'yup';
import {
  TextField,
  FormHelperText,
  Button,
  MenuItem,
  FormControl,
  Checkbox,
  InputAdornment,
} from '@material-ui/core';
// import {nameRegexAllow} from '../../../../../util/RegexPatterns';
// import {nameWithSpecialCharacter} from '../../../../../util/Content';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {useSelector, useDispatch} from 'react-redux';
import {getAllReportCreatedForData} from '../../../../../redux/reducers/ReportMaster';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {
  postBasicInfo,
  fetchBasicInfoData,
  fetchAllDataManagerCode,
  resetMsgAndStatus,
  getExportFormatType,
} from '../../../../../redux/reducers/DataManager';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
// import {currsorCodeIssue} from '../../../../../components/UpperCaseCode';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import DialogBox from '../../../../../components/DialogBox';
import AddFileName from './AddFileName';
import {EXPORT_FORMAT_TYPE} from '../../../../../constants/Lookup';
import {getOptions} from '../../../../../util/GetDropDownOptions';
import ReportFolderPath from '../../../Reports/AddReport/StepperComponents/ReportFolderPath';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';
import {createForOptions} from '../../../../../util/CreatedByForOptions';
import { currsorCodeIssue } from '../../../../../components/UpperCaseCode';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const promptOptions = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];

const importManagerType = [
  {value: 'New Account Import'},
  // { value: "New Payment Import" },
  {value: 'Data Update'},
  {value: 'Customer Query'},
];
const exportManagerType = [{value: 'Data Export'}];
const DMBasicInfo = ({
  activeStep,
  handleNext,
  exportManager,
  handleLabelChange,
  handleHideStep,
  handleDirty,
  editExisting,
  DataManagerAccess,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);

  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {reportCreatedForData} = useSelector(({reportMaster}) => reportMaster);
  const {clientCodeDropdownData} = useSelector(({addTriggerGroup}) => addTriggerGroup);
  const [folderPath, setFolderPath] = useState(false);
  const codeRef = useRef();
  const {
    isBasicInfoLoading,
    basicInfoErrorMsg,
    basicInfoSuccessMsg,
    addBasicInfoStatus,
    dataManagerId,
    basicInfoData,
    allDataManagerCode,
    exportFormatTypeData,
  } = useSelector(({dataManagerGroup}) => dataManagerGroup);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const [codePopover, setCodePopover] = useState(false);
  const [DMCodesData, setDMCodesData] = useState();
  const [open, setOpen] = useState(false);
  const saveRef = useRef();
  const type = exportManager ? 'Export' : 'Import';
  const exportType = type === 'Export' ? 'Export' : 'Import';
  const importCondition = exportType === "Import" ? true : false;
  const changesToWrite = [{value: 'All Changes'}, {value: 'Last Change'}];
  const strategyType = [
    {value: 'Changed Field From Audit & Other fields Blank'},
    {value: 'Changed fields from Audit & Others from Account'},
    {value: 'Changed fields from Account & Other Blank'},
    {value: 'Fill from Account'},
  ];

  const categoryData = [
    {
      categoryCode: 'CO',
      categoryName: 'Core',
    },
  ];
  const handleClose = () => {
    setOpen(false);
    setFolderPath(false);
  };

  const getObjects = (option, typeCode) => {
    const options =
      exportFormatTypeData && exportFormatTypeData[typeCode] ? exportFormatTypeData[typeCode] : [];
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item?.valueCode === option.toString() || item.value === option) {
          label = item;
        }
      });
    return label;
  };

  const checkDataMangerCodeExist = (value) => {
    if (allDataManagerCode && allDataManagerCode?.length > 0 && value) {
      const ar = [];
      allDataManagerCode.filter((i) => {
        if (
          i?.dmCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'Y'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  const checkDataMangerCodeAlreadyExist = (value) => {
    if (allDataManagerCode && allDataManagerCode?.length > 0 && value) {
      const ar = [];
      allDataManagerCode.filter((i) => {
        if (
          i?.dmCode?.toLowerCase()?.trim() === value?.toLowerCase()?.trim() &&
          i?.isActive === 'N'
        ) {
          ar.push(i);
        }
      });
      return ar.length > 0;
    } else {
      return false;
    }
  };
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);

  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (
          item.value === option ||
          item.key === option ||
          item.userName === option || item.userLoginName === option ||
          item.categoryCode === option
        ) {
          label = item;
        }
      });
    return label;
  };
  const getClientCodes = (user, clientCodeData) => {
    return clientCodeData?.filter((i) => user?.includes(i?.clientNumber));
  };
  const user = JSON.parse(sessionStorage.getItem('userDetails'));
  const initialVal = {
    code: basicInfoData?.dmCode ? basicInfoData?.dmCode : '',
    description: basicInfoData?.dmDescription ? basicInfoData?.dmDescription : '',
    clientPrompt: basicInfoData?.clientIdPrompt ?
      getObject(basicInfoData?.clientIdPrompt, promptOptions) :
      {key: 'N', value: 'No'},
    auditPrompt: basicInfoData?.auditDatesPrompt ?
      getObject(basicInfoData?.auditDatesPrompt, promptOptions) :
      {key: 'N', value: 'No'},
    dmType: exportManager ?
      {value: 'Data Export'} :
      basicInfoData?.dmType ?
        getObject(basicInfoData?.dmType, [...exportManagerType, ...importManagerType]) :
        '',
    createdFor: basicInfoData?.createdFor ?
      getObject(basicInfoData?.createdFor, reportCreatedForData) :
      {userLoginName: user?.userName},
    multiRecordFormat: basicInfoData?.multiRecordFormat ?
      getObject(basicInfoData?.multiRecordFormat, promptOptions) :
      {key: 'N', value: 'No'},
    category: basicInfoData?.category ?
      getObject(basicInfoData?.category, categoryData) :
      {categoryCode: 'CO', categoryName: 'Core'},
    changesToWrite:
      exportManager && basicInfoData?.changeToWrite ?
        getObject(basicInfoData?.changeToWrite, changesToWrite) :
        '',
    strategy:
      exportManager && basicInfoData?.fieldStrategy ?
        getObject(basicInfoData?.fieldStrategy, strategyType) :
        '',
    includeAudit: basicInfoData?.includeAudit ?
      getObject(basicInfoData?.includeAudit, promptOptions) :
      {key: 'N', value: 'No'},
    user:
      basicInfoData?.clientNumbers?.length > 0 ?
        getClientCodes(basicInfoData?.clientNumbers, clientCodeDropdownData) :
        [],
    outputFileName: basicInfoData?.reportOutputFileName ? basicInfoData?.reportOutputFileName : '',
    exportFormat: basicInfoData?.exportFormatType ?
      getObjects(basicInfoData?.exportFormatType, EXPORT_FORMAT_TYPE, exportFormatTypeData) :
      '',
    reportpath: basicInfoData?.exportfolderPath ? basicInfoData?.exportfolderPath : '',
  };

  const validationSchema = Yup.object().shape({
    description: Yup.string()
      .test('description', 'Description is required', (value) => {
        return value?.replaceAll(' ', '');
      })
      .max(100, 'Description cannot exceed 100 characters')
      .required('Description is required'),
    category: exportManager && Yup.object().required('Category is required').nullable(),
    includeAudit: exportManager && Yup.mixed().required('Include Audit is required').nullable(),
    code: basicInfoData?.dmCode ?
      null :
      Yup.string()
        .required(`${exportManager ? 'Export' : 'Import'} Name is required`)
        // .max(25, `${exportManager ? 'Export' : 'Import'} Name cannot exceed 25 characters`)
        // .test('Code', 'Multiple hyphen(-) are not allowed', (value) => {
        //   if (value?.slice(-2) === '--') {
        //     return false;
        //   } else {
        //     return true;
        //   }
        // })
        // .matches(nameRegexAllow, nameWithSpecialCharacter)
        .test('code', `${exportManager ? 'Export' : 'Import'} Name already exist`, (value) => !checkDataMangerCodeExist(value))
        .test(
          'code',
              `${exportManager ? 'Export' : 'Import'} Name has already been used in the past`,
              (value) => !checkDataMangerCodeAlreadyExist(value),
        ),
    clientPrompt: Yup.mixed().test('clientPrompt', 'Client Id Prompt is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    changesToWrite: Yup.mixed().test(
      'changesToWrite',
        `Changes To Write is required`,
        (value, ctx) => {
          if (!value?.value && exportManager && ctx.parent.includeAudit?.key === 'Y') {
            return false;
          } else {
            return true;
          }
        },
    ),
    strategy: Yup.mixed().test('strategy', `Field Populate Strategy is required`, (value, ctx) => {
      if (!value?.value && exportManager && ctx.parent.includeAudit?.key === 'Y') {
        return false;
      } else {
        return true;
      }
    }),
    dmType: Yup.mixed().test('dmType', `Type is required`, (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    auditPrompt: Yup.mixed().test('auditPrompt', 'Audit Prompt is required', (value, ctx) => {
      if (!value?.value && ctx.parent.dmType?.value === 'Data Export') {
        return false;
      } else {
        return true;
      }
    }),

    createdFor: Yup.mixed().test('createdFor', 'Created For is required', (val) => {
      if (!val?.userLoginName) {
        return false;
      } else {
        return true;
      }
    }),
    multiRecordFormat: Yup.mixed().test(
      'multiRecordFormat',
      'Multi Record Format is Required',
      (val) => {
        if (!val?.key) {
          return false;
        } else {
          return true;
        }
      },
    ),
    exportFormat: Yup.mixed().test(
      'exportFormat',
      'Export Format Type is required',
      (value, ctx) => {
        if (!value?.value && ctx.parent.dmType?.value === 'Data Export') {
          return false;
        } else {
          return true;
        }
      },
    ),
    reportpath: exportType === 'Export' &&
      Yup
        .mixed()
        .test('reportpath', `Invalid Folder path, Can't contain // and \\`, function(value, context) {
          // const regex = /^(?!.*\/\/)/;
          const regex = /^(?!.*\\|.*\/\/).*$/;
          const {parent} = context;
          if (regex.test(parent?.reportpath)) {
            return true;
          } else {
            return false;
          }
        }),
    outputFileName: Yup
      .mixed()
      .test('outputFileName', 'Invalid characters in output file name', function(value, context) {
        const disallowedCharsRegex = /[\/\\:*?"'<>|]/;
        const { parent } = context;
    
        if (disallowedCharsRegex.test(parent?.outputFileName)) {
          return false;  // Invalid characters found
        } else {
          return true;   // Valid characters
        }
      }),
  });
  const handleSubmit = (values) => {
    dispatch(submissionStart());
    const clientNumber =
      values?.user?.length > 0 ? values?.user?.map((el) => el?.clientNumber) : [];
    const payload = {
      clientIdPrompt: values?.clientPrompt?.key ? values?.clientPrompt?.key : '',
      createdFor: values?.createdFor?.userLoginName ? values?.createdFor?.userLoginName : '',
      dataManagerId: basicInfoData?.dataManagerId ? basicInfoData?.dataManagerId : 0,
      dmCode: values?.code ? values?.code : '',
      dmDescription: values?.description ? values?.description : '',
      dmType: values?.dmType?.value ? values?.dmType?.value : '',
      multiRecordFormat: values?.multiRecordFormat?.key ? values?.multiRecordFormat?.key : '',
      lastStep: saveRef.current ? 0 : 1,
      tabType: type,
      isDraft: basicInfoData?.isDraft ? basicInfoData?.isDraft : 'Y',
      includeAudit: exportManager && values?.includeAudit?.key ? values?.includeAudit?.key : '',
      auditDatesPrompt: exportManager && values?.auditPrompt?.key ? values?.auditPrompt?.key : '',
      changeToWrite:
        exportManager && values?.changesToWrite?.value ? values?.changesToWrite?.value : '',
      fieldStrategy: exportManager && values?.strategy?.value ? values?.strategy?.value : '',
      category:
        exportManager && values?.category?.categoryCode ? values?.category?.categoryCode : '',
      clientNumbers: clientNumber,
      reportOutputFileName:values?.outputFileName ? values?.outputFileName : '',
      exportFormatType: values?.exportFormat?.value ? values?.exportFormat?.value : '',
      exportfolderPath: values?.reportpath ? values?.reportpath : '',
    };
    dispatch(postBasicInfo(payload));
  };


  useEffect(() => {
    dispatch(getAllReportCreatedForData());
    dispatch(getExportFormatType());
  }, []);

  useEffect(() => dispatch(resetMsgAndStatus()), []);
  useEffect(() => {
    if (basicInfoSuccessMsg || basicInfoErrorMsg) {
      setTimeout(() => {
        if (addBasicInfoStatus === 200 && basicInfoSuccessMsg && !saveRef.current) {
          handleNext('0');
        }
        dispatch(resetMsgAndStatus());
      }, 1500);
    }
  }, [basicInfoErrorMsg, basicInfoSuccessMsg]);

  useEffect(() => {
    if (dataManagerId) {
      dispatch(fetchBasicInfoData({dataManagerId, tabType: exportManager ? 'Export' : 'Import'}));
    }
  }, [dataManagerId]);

  useEffect(() => {
    dispatch(fetchAllDataManagerCode(type));
  }, []);

  window.onclick = function() {
    setCodePopover(false);
  };

  const getRecordCodesData = () => {
    if (allDataManagerCode && allDataManagerCode?.length > 0) {
      return allDataManagerCode?.filter((i) => String(i.dmCode)?.toLowerCase()?.startsWith(DMCodesData?.toLowerCase()));
    } else {
      return [];
    }
  };
  return (
    <>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialVal}
        validationSchema={validationSchema}
        enableReinitialize
        validateOnBlur
      >
        {(props) => {
          const {
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            setFieldValue,
            dirty,
          } = props;
          handleDirty && handleDirty(dirty);
          handleLabelChange(values?.multiRecordFormat?.value === 'Yes');
          handleHideStep(['Customer Query']?.includes(values?.dmType?.value));
          return (
            <form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <div className="form-row global-field-textfields new-standard-textfields mt-2">
                <div className={`col-sm-6 col-md-4 col-xl-3 form-group`}>
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter ${type} Name`}
                    label={`${type} Name`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="code"
                    required
                    inputProps={{maxLength: 25}}
                    value={values?.code}
                    disabled={Boolean(basicInfoData?.dmCode)}
                    inputRef={codeRef}
                    onChange={(e) => {
                      const value = currsorCodeIssue(codeRef);
                      setFieldValue('code', value);
                      if (e.target.value) {
                        setCodePopover(true);
                        setDMCodesData(e.target.value);
                      } else if (e.target.value === '') {
                        setCodePopover(false);
                      }
                    }}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.code}
                    error={Boolean(touched.code && errors.code)}
                  />
                  <FormHelperText>{touched.code && errors?.code && errors.code}</FormHelperText>
                  <div className="windowcode-popover Add-trigger-group-popover">
                    {codePopover &&
                      getRecordCodesData()?.map((data, i) => (
                        <MenuItem fullWidth key={i}>
                          {data?.dmCode?.replace(/ /g, '\u00a0')}
                        </MenuItem>
                      ))}
                  </div>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter Description`}
                    label={`Description`}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name="description"
                    required
                    inputProps={{maxLength: 100}}
                    value={values.description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    fullWidth
                    touched={touched.description}
                    error={Boolean(touched.description && errors.description)}
                  />
                  <FormHelperText>
                    {touched.description && errors?.description && errors.description}
                  </FormHelperText>
                </div>
                {exportManager && (
                  <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="category"
                      value={values?.category}
                      options={categoryData?.length > 0 ? categoryData : []}
                      size="small"
                      autoHighlight
                      disabled={Boolean(basicInfoData?.category)}
                      getOptionDisabled={(option) => option?.categoryCode === null}
                      getOptionLabel={(option) => {
                        return option && option?.categoryName
                          ? option?.categoryCode === null
                            ? option?.categoryName
                            : option?.categoryCode + ' - ' + option?.categoryName
                          : '';
                      }}
                      renderInput={(params) => (
                        <GuiTextField
                          {...params}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          className={` ${classes.labelName}`}
                          variant="outlined"
                          fullWidth
                          margin="dense"
                          label="Category"
                          name="category"
                          required
                          placeholder="Select Category"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off',
                          }}
                        />
                      )}
                      onChange={(e, data) => {
                        // dispatch(setCategoryRedux({ property: "category", value: data }));
                        // props.onChange(data);
                        setFieldValue('category', data);
                        // setSelectedBaseCategory(data?.categoryCode);
                      }}
                    />
                    <FormHelperText variant="outlined">
                      {touched.category && errors.category}
                    </FormHelperText>
                  </div>
                )}
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                      popper: classes.popper,
                    }}
                    name="createdFor"
                    id="createdFor"
                    size="small"
                    value={values.createdFor}
                    options={reportCreatedForData}
                    // disabled={Boolean(basicInfoData?.createdFor)}
                    getOptionLabel={(option) => {
                      return option && option?.userLoginName ? option?.userLoginName : '';
                    }}
                    renderOption={(option) => {
                      return createForOptions(option);
                    }}
                    onChange={(e, value) => {
                      setFieldValue('createdFor', value);
                    }}
                    placeholder="Select created For"
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          className={` ${classes.labelName}`}
                          {...params}
                          error={touched.createdFor && errors.createdFor}
                          variant="outlined"
                          margin="dense"
                          required
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          label="Created For"
                          placeholder="Select Created For"
                        />
                      </div>
                    )}
                  />
                  <FormHelperText style={{ color: 'red' }} variant="outlined">
                    {touched.createdFor && errors.createdFor}
                  </FormHelperText>
                </div>
                {!exportManager ? (
                  <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      name="dmType"
                      id="dmType"
                      size="small"
                      options={importManagerType}
                      required
                      value={values.dmType}
                      disabled={Boolean(basicInfoData?.dmType)}
                      getOptionLabel={(option) => {
                        return option && option.value;
                      }}
                      onChange={(e, value) => {
                        setFieldValue('dmType', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{ shrink: true }}
                            label={`Type`}
                            placeholder={`Select Type`}
                            required
                            error={touched.dmType && errors.dmType}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {touched.dmType && errors.dmType && errors.dmType}
                    </FormHelperText>
                  </div>
                ) : null}
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      popper: classes.popper,
                      option: classes.option,
                    }}
                    name="clientPrompt"
                    id="clientPrompt"
                    size="small"
                    options={promptOptions}
                    required
                    value={values.clientPrompt}
                    disabled={Boolean(basicInfoData?.clientIdPrompt)}
                    getOptionLabel={(option) => {
                      return option && option.value;
                    }}
                    onChange={(e, value) => {
                      setFieldValue('clientPrompt', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName}`}
                          variant="outlined"
                          margin="dense"
                          // InputLabelProps={{ shrink: true }}
                          label="Client Id Prompt"
                          placeholder="Select Client Id Prompt"
                          required
                          error={touched.clientPrompt && errors.clientPrompt}
                        />
                      </div>
                    )}
                  />
                  <FormHelperText>
                    {touched.clientPrompt && errors.clientPrompt && errors.clientPrompt}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                  <GuiAutoComplete
                    classes={{
                      option: classes.option,
                    }}
                    name="multiRecordFormat"
                    id="multiRecordFormat"
                    size="small"
                    options={promptOptions}
                    required
                    value={values.multiRecordFormat}
                    disabled={Boolean(basicInfoData?.multiRecordFormat)}
                    getOptionLabel={(option) => {
                      return option && option.value;
                    }}
                    onChange={(e, value) => {
                      setFieldValue('multiRecordFormat', value);
                    }}
                    renderInput={(params) => (
                      <div className="select-field">
                        <GuiTextField
                          {...params}
                          className={` ${classes.labelName}`}
                          variant="outlined"
                          margin="dense"
                          // InputLabelProps={{ shrink: true }}
                          label="Multi Record Format"
                          placeholder="Select Multi Record Format"
                          required
                          error={touched.multiRecordFormat && errors.multiRecordFormat}
                        />
                      </div>
                    )}
                  />
                  <FormHelperText>
                    {touched.multiRecordFormat &&
                      errors.multiRecordFormat &&
                      errors.multiRecordFormat}
                  </FormHelperText>
                </div>
                {exportManager && (
                  <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      name="includeAudit"
                      id="includeAudit"
                      size="small"
                      options={promptOptions}
                      required
                      value={values.includeAudit}
                      disabled={Boolean(basicInfoData?.includeAudit)}
                      getOptionLabel={(option) => {
                        return option && option.value;
                      }}
                      onChange={(e, value) => {
                        setFieldValue('includeAudit', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{ shrink: true }}
                            label="Include Audit"
                            placeholder="Select Include Audit"
                            required
                            error={touched.includeAudit && errors.includeAudit}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {touched.includeAudit && errors.includeAudit && errors.includeAudit}
                    </FormHelperText>
                  </div>
                )}
                {exportManager && values?.includeAudit?.value === 'Yes' && (
                  <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      name="auditPrompt"
                      id="auditPrompt"
                      size="small"
                      options={promptOptions}
                      required
                      value={values.auditPrompt}
                      disabled={Boolean(basicInfoData?.auditDatesPrompt)}
                      getOptionLabel={(option) => {
                        return option && option.value;
                      }}
                      onChange={(e, value) => {
                        setFieldValue('auditPrompt', value);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            margin="dense"
                            // InputLabelProps={{ shrink: true }}
                            label="Audit Prompt"
                            placeholder="Select Audit Prompt"
                            required
                            error={touched.auditPrompt && errors.auditPrompt}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText>
                      {touched.auditPrompt && errors.auditPrompt && errors.auditPrompt}
                    </FormHelperText>
                  </div>
                )}
                {exportManager && values?.includeAudit?.value === 'Yes' && (
                  <>
                    <div className={`col-sm-6 col-md-4 col-xl-3  form-group`}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        id="changesToWrite"
                        options={changesToWrite}
                        value={values?.changesToWrite}
                        size="small"
                        autoHighlight
                        disabled={Boolean(basicInfoData?.changeToWrite)}
                        getOptionLabel={(option) => {
                          return option && option.value;
                        }}
                        onChange={(e, data) => {
                          setFieldValue('changesToWrite', data);
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            margin="dense"
                            {...params}
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            fullWidth
                            label="Changes To write"
                            required
                            error={Boolean(touched.changesToWrite && errors.changesToWrite)}
                            name="changesToWrite"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            placeholder="Select Changes To write"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        )}
                      />
                      <FormHelperText style={{ color: 'red' }} variant="outlined">
                        {touched.changesToWrite && errors.changesToWrite}
                      </FormHelperText>
                    </div>
                    <div className={`col-sm-6 col-md-4 col-xl-3 form-group`}>
                      <GuiAutoComplete
                        classes={{
                          option: classes.option,
                        }}
                        id="strategy"
                        options={strategyType}
                        value={values?.strategy}
                        disabled={Boolean(basicInfoData?.fieldStrategy)}
                        size="small"
                        autoHighlight
                        getOptionLabel={(option) => {
                          return option && option.value ? option.value : '';
                        }}
                        onChange={(e, data) => {
                          setFieldValue('strategy', data);
                        }}
                        renderInput={(params) => (
                          <GuiTextField
                            margin="dense"
                            {...params}
                            className={` ${classes.labelName}`}
                            variant="outlined"
                            fullWidth
                            label="Field Populate Strategy"
                            required
                            error={Boolean(touched.strategy && errors.strategy)}
                            name="strategy"
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            placeholder="Select Field Populate Strategy"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        )}
                      />
                      <FormHelperText style={{ color: 'red' }} variant="outlined">
                        {touched.strategy && errors.strategy}
                      </FormHelperText>
                    </div>
                  </>
                )}
                {type === 'Export' && (
                  <div className="col-sm-6 col-md-4 col-xl-3 form-group">
                    <GuiAutoComplete
                      classes={{
                        popper: classes.popper,
                        option: classes.option,
                      }}
                      id="exportFormat"
                      size="small"
                      autoHighlight
                      value={values?.exportFormat}
                      options={
                        // exportFormatType
                        getOptions(EXPORT_FORMAT_TYPE, exportFormatTypeData)
                        // fixedlength === "Y"
                        //   ? getOptions(FILE_TYPE, dropDownData)?.filter(
                        //       (each) => each?.value === "Text"
                        //     )
                        //   : getOptions(FILE_TYPE, dropDownData)
                      }
                      // getOptionDisabled={(option) => option?.valueCode === "none"}
                      getOptionLabel={(option) => {
                        return option?.value ? option?.value : '';
                      }}
                      onChange={(_, data) => {
                        setFieldValue('exportFormat', data);
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            className={` ${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            fullWidth
                            label="Export Format Type"
                            error={Boolean(touched.exportFormat && errors.exportFormat)}
                            name="exportFormat"
                            required
                            // InputLabelProps={{
                            //   shrink: true,
                            // }}
                            placeholder="Select Export Format Type"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText style={{ color: 'red', paddingTop: '5px' }} variant="outlined">
                      {touched.exportFormat && errors.exportFormat && errors.exportFormat}
                    </FormHelperText>
                  </div>
                )}
                <div
                  className={`col-sm-6 col-md-4 col-xl-3 form-group autocomplete-field ${
                    values?.user?.length > 3 && `autocomplete-checkbox`
                  }`}
                >
                  <FormControl margin="dense" variant="outlined" fullWidth>
                    <GuiAutoComplete
                      className={` ${classes.labelName}`}
                      name={'user'}
                      id={'user'}
                      size="small"
                      limitTags={1}
                      classes={{
                        option: classes.option,
                        listbox: classes.listBox,
                      }}
                      disableCloseOnSelect
                      getOptionSelected={(option, value) =>
                        option?.clientNumber === value?.clientNumber
                      }
                      value={values?.user?.length > 0 ? values?.user : []}
                      multiple
                      onChange={(e, value) => {
                        handleChange(e);
                        setFieldValue('user', value);
                      }}
                      options={clientCodeDropdownData || []}
                      autoHighlight
                      renderOption={(option, { selected }) => {
                        return (
                          <React.Fragment>
                            <>
                              <Checkbox
                                icon={icon}
                                checkedIcon={
                                  <CheckBoxIcon fontSize="small" className="selectcheckBox" />
                                }
                                checked={selected}
                                className={classes.checkBox}
                              />
                            </>
                            {option?.clientName}
                          </React.Fragment>
                        );
                      }}
                      getOptionLabel={(option) => {
                        return option?.clientName;
                      }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            {...params}
                            variant="outlined"
                            margin="dense"
                            touched={touched}
                            error={touched?.user && errors?.user}
                            // InputLabelProps={{ shrink: true }}
                            label={'Client Code'}
                            placeholder={`Select Client Code`}
                            className={`autocomplete-multiselect-label mt-0`}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off', // disable autocomplete and autofill
                            }}
                          />
                        </div>
                      )}
                    />
                  </FormControl>
                  <FormHelperText variant="outlined">
                    {touched?.user && errors?.user ? errors.user : ''}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3 report-path">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter ${importCondition ? 'Exception' : exportType} Folder Path`}
                    label={`${importCondition ? 'Exception' : exportType} Folder Path`}
                    multiline
                    rows={2}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          style={{ cursor: 'pointer' }}
                          onClick={() => setFolderPath(true)}
                          position="start"
                        >
                          <AddBoxOutlinedIcon />
                        </InputAdornment>
                      ),
                    }}
                    // InputLabelProps={{
                    //   shrink: true,
                    // }}
                    name={'reportpath'}
                    value={values?.reportpath}
                    onChange={(e) => {
                      setFieldValue('reportpath', e.target.value);
                    }}
                    fullWidth
                    touched={touched.reportpath}
                    error={touched.reportpath && errors.reportpath}
                  />
                  <FormHelperText style={{ color: 'red', paddingTop: '5px' }} variant="outlined">
                    {touched.reportpath && errors.reportpath && errors.reportpath}
                    {''}
                  </FormHelperText>
                </div>
                <div className="col-sm-6 col-md-4 col-lg-4 col-xl-3 report-path-output">
                  <TextField
                    className={` ${classes.labelName}`}
                    margin="dense"
                    variant="outlined"
                    placeholder={`Enter ${importCondition ? 'Exception' : exportType} Output File Name`}
                    label={`${importCondition ? 'Exception' : exportType} Output File Name`}
                    multiline
                    rows={2}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment
                          style={{ cursor: 'pointer' }}
                          position="start"
                          onClick={() => setOpen(true)}
                        >
                          <AddBoxOutlinedIcon />
                        </InputAdornment>
                      ),
                    }}
                    name={'outputFileName'}
                    value={values?.outputFileName}
                    onChange={(e) => {
                      setFieldValue('outputFileName', e.target.value);
                    }}
                    fullWidth
                    touched={touched.outputFileName}
                    error={touched.outputFileName && errors.outputFileName}
                  />
                  <FormHelperText
                    style={{color: 'red', paddingTop: '5px', marginBottom: "5px"}}
                    variant="outlined"
                  >
                    {touched.outputFileName && errors.outputFileName && errors.outputFileName}
                    {''}
                  </FormHelperText>
                    
                </div>
                {/* <TextField
                      margin="dense"
                      variant="outlined"
                      className={` ${classes.labelName}`}
                      placeholder={`Enter Export Output File Name`}
                      label={"Export Output File Name"}
                      multiline
                      rows={2}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment
                            style={{ cursor: "pointer" }}
                            position="start"
                            onClick={() => setOpen(true)}
                          >
                            <AddBoxOutlinedIcon />
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      name={"outputFileName"}
                      value={values?.outputFileName}
                      onChange={(e) => {
                        setFieldValue("outputFileName", e.target.value);
                      }}
                      fullWidth
                      touched={touched.outputFileName}
                      error={touched.outputFileName && errors.outputFileName}
                    /> */}
              </div>
              <DialogBox
                open={open}
                dialogClose={handleClose}
                hideFooter={true}
                maxWidth={'xl'}
                title={`${importCondition ? 'Exception' : exportType}  File Name`}
              >
                <AddFileName
                  setFieldValues={setFieldValue}
                  setOpen={setOpen}
                  addValues={values}
                  handleClose={handleClose}
                  export={true}
                  exportType={exportType}
                />
              </DialogBox>
              <DialogBox
                open={folderPath}
                dialogClose={handleClose}
                hideFooter={true}
                maxWidth={'xl'}
                title={`${importCondition ? 'Exception' : exportType} Folder Path`}
              >
                <ReportFolderPath
                  setFieldValues={setFieldValue}
                  setOpen={setOpen}
                  addValues={values}
                  handleClose={handleClose}
                  folderPath={folderPath}
                  export={true}
                  exportType={exportType}
                />
              </DialogBox>
              <div className="d-flex justify-content-center align-items-center new-standard-textfields disabled-button mt-3">
                <Button
                  variant="outlined"
                  disabled={activeStep === 0}
                  className={`reset-btn mr-1 mt-2 ${classes.buttonRoot}`}
                >
                  Back
                </Button>
                {/* {basicInfoData?.isDraft === "N" && ( */}
                <Button
                  variant="outlined"
                  type="button"
                  className={`search-btn ml-1 mr-1 mt-2 ${classes.buttonRoot}`}
                  disabled={(editExisting && !DataManagerAccess?.edit) || enabledSubmission}
                  onClick={() => {
                    saveRef.current = true;
                    handleDirty(false, 'fixed');
                    handleSubmit(values);
                  }}
                >
                  Save
                </Button>
                {/* )} */}
                <Button
                  variant="outlined"
                  type="submit"
                  className={`search-btn ml-1 mt-2 ${classes.buttonRoot}`}
                  disabled={(editExisting && !DataManagerAccess?.edit) || enabledSubmission}
                  onClick={() => {
                    saveRef.current = false;
                  }}
                >
                  Save & Next
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
      {isBasicInfoLoading && <PageLoader />}
      {basicInfoErrorMsg && <ErrorSnackbar errorMsg={basicInfoErrorMsg} />}
      {basicInfoSuccessMsg && <SuccessSnackbar successMsg={basicInfoSuccessMsg} />}
    </>
  );
};

export default DMBasicInfo;
